import React, { useState } from 'react';
import exchangeService from '../../services/exchangeService';
import { FaTimes } from 'react-icons/fa';
import '../../ReportModal.css';

// 이 컴포넌트는 채팅방(ChatRoom)이나 통화방(CallRoom)에서
// "신고하기" 버튼을 눌렀을 때 화면 위에 띄우는 팝업(모달)이다.
// targetId: 신고당하는 상대방의 user id
// targetNickname: 화면에 보여줄 상대방 닉네임 (없어도 동작함)
// onClose: 모달을 닫을 때 부모 컴포넌트가 실행할 함수
const ReportModal = ({ targetId, targetNickname, onClose }) => {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');

    if (!reason.trim()) {
      setErrorMessage('신고 사유를 입력해달라.');
      return;
    }

    try {
      setSubmitting(true);
      await exchangeService.sendReport(targetId, reason.trim());
      setSubmitted(true);
    } catch (err) {
      console.error('신고 접수 오류:', err);
      const serverMessage = err.response && err.response.data && err.response.data.message;
      setErrorMessage(serverMessage || '신고 접수 중 오류가 발생했다.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="report-modal-overlay" onClick={onClose}>
      <div className="report-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="report-modal-header">
          <h3>{targetNickname ? `${targetNickname}님 신고하기` : '신고하기'}</h3>
          <button className="report-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        {submitted ? (
          <div className="report-modal-body">
            <p className="report-success-message">신고가 접수되었다. 관리자가 확인 후 처리할 것이다.</p>
            <button className="report-modal-confirm-button" onClick={onClose}>
              닫기
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="report-modal-body">
            <p className="report-modal-description">
              부적절한 행동이나 불편했던 점을 구체적으로 적어달라. 관리자가 검토 후 조치한다.
            </p>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="예: 대화 중 부적절한 언행을 했다."
              rows={4}
              maxLength={500}
            />
            {errorMessage && <div className="report-error">{errorMessage}</div>}
            <div className="report-modal-actions">
              <button type="button" className="report-cancel-button" onClick={onClose}>
                취소
              </button>
              <button type="submit" className="report-submit-button" disabled={submitting}>
                {submitting ? '접수 중이다...' : '신고하기'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ReportModal;
